import { WorldClockColumn } from '../../../models/world-clock-column.model';
import { WorldClockLocalTimeLog } from '../../../models/world-clock-log.model';

export const WORLD_CLOCK_COLUMNS: readonly WorldClockColumn[] = [
  { key: 'market', header: 'Market', accessor: (l: WorldClockLocalTimeLog) => l.market },
  { key: 'timeZone', header: 'Time Zone', accessor: (l: WorldClockLocalTimeLog) => l.timeZone },
  { key: 'utcOffset', header: 'UTC Offset', accessor: (l: WorldClockLocalTimeLog) => l.utcOffset },
  { key: 'localTime', header: 'Local Time', accessor: (l: WorldClockLocalTimeLog) => l.local.time },
] as const;
